<template>
  <div>
    <a-row :gutter="[16,16]" class="mb-3 mt-1">
      <a-col>
        <date-time
          :getParams.sync="dateParam"
          :dateMode.sync="dateMode"
          :defaultDateMode="defaultDateMode"
          :disableLocalTime="hasDefaultDate"
          start="start_day"
          end="end_day"
          paramTimeFormatter="YYYYMMDD"
          showStartMonthTip
          isHideCustomAdvanced
          @refresh="fetchCoverageData" />
      </a-col>
    </a-row>
    <header class="ri-header mb-3">{{ $t('bill.ri_usage_header') }}</header>
    <a-row :gutter="12">
      <a-col :span="12">
        <ri-card
          class="mb-2"
          :title="$t('bill.ri_cover_title')"
          :value="coverage"
          :showUnit="false"
          height="122px" />
      </a-col>
      <a-col :span="12">
        <ri-card
          class="mb-2"
          :title="$t('bill.ri_usage_title')"
          :value="utilization"
          :showUnit="false"
          height="122px" />
      </a-col>
    </a-row>
    <header class="ri-header mb-3">{{ $t('bill.ri_coverage_header') }}</header>
    <div class="mt-3">
      <ri-coverage
        ref="coverageList"
        :cloudaccount-id="data.id"
        :date-param="dateParam"
        list-id="riCoverageListForAccount"
        @coverage-stats="onCoverageStats" />
    </div>
    <!-- <header class="ri-header mb-3">
      <span>{{ $t('bill.ri_recommend_header') }}</span>
      <a-switch v-model="run_reservation" @change="onAwsRICallChange" style="margin-left: 10px;margin-right: 10px;" />
      <span class="text-color-secondary" style="font-size:small;">{{ riReservationTips }}</span>
    </header>
    <a-row :gutter="[16,16]" v-if="run_reservation">
      <a-col :sm="12" :xl="6">
        <a-select class="w-100" dropdownClassName="oc-select-dropdown" v-model="search.lookback_days">
          <a-select-option v-for="item in LOOKBACK_DAYS" :value="item.key" :key="item.key">
            <span class="text-color-secondary option-prefix">{{ $t('bill.ri_lookback_days') }}: </span>{{ item.value }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :sm="12" :xl="6">
        <a-select class="w-100" dropdownClassName="oc-select-dropdown" v-model="search.reservation_years">
          <a-select-option v-for="item in RESERVATION_YEARS" :value="item.key" :key="item.key">
            <span class="text-color-secondary option-prefix">{{ $t('bill.ri_reservation_years') }}: </span>{{ item.value }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :sm="12" :xl="6" v-if="data.brand === 'Aws'">
        <a-select class="w-100" dropdownClassName="oc-select-dropdown" v-model="search.payment_option">
          <a-select-option v-for="item in PAYMENT_OPTIONS" :value="item.key" :key="item.key">
            <span class="text-color-secondary option-prefix">{{ $t('bill.ri_payment_option') }}: </span>{{ item.value }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :sm="12" :xl="6" v-if="data.brand === 'Aws'">
        <a-select class="w-100" dropdownClassName="oc-select-dropdown" v-model="search.offering_class">
          <a-select-option v-for="item in OFFERING_CLASS" :value="item.key" :key="item.key">
            <span class="text-color-secondary option-prefix">{{ $t('bill.ri_payment') }}: </span>{{ item.value }}
          </a-select-option>
        </a-select>
      </a-col>
    </a-row>
    <div class="mt-3" v-if="run_reservation">
      <page-list
        :list="list"
        :columns="columns"
        :export-data-options="exportDataOptions">
        <div class="mt-2 mb-1" slot="table-prepend">
          <span>{{ $t('bill.ri_sum') }}</span>
          <span class="money">{{ total_monthly_savings_amount }}</span>
        </div>
      </page-list>
    </div> -->
  </div>
</template>

<script>
import RiCard from '@Bill/sections/RiCard'
import RiCoverage from '@Bill/views/ri-coverage'
import { numerify } from '@/filters'
import {
  LOOKBACK_DAYS,
  RESERVATION_YEARS,
  PAYMENT_OPTIONS,
  OFFERING_CLASS,
  RESERVATION_YEARS_MAP,
  PAYMENT_OPTIONS_MAP,
  OFFERING_CLASS_MAP,
} from '@Bill/constants'
import ListMixin from '@/mixins/list'
import WindowsMixin from '@/mixins/windows'
import { uuid } from '@/utils/utils'
import BillProgress from '@Bill/sections/BillProgress'
import { getBillResourceTypeLabel } from '@Bill/utils'
import { currencyUnitMap } from '@/constants/currency'

export default {
  name: 'RiOverview',
  components: {
    RiCard,
    RiCoverage,
  },
  mixins: [WindowsMixin, ListMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    defaultDate: {
      type: Object,
      default: () => ({}),
    },
    defaultDateMode: {
      type: String,
      default: 'month',
    },
  },
  data () {
    const defaultDateParam = this.getInitialDateParam()
    return {
      dateMode: this.defaultDateMode,
      dateParam: defaultDateParam,
      LOOKBACK_DAYS,
      RESERVATION_YEARS,
      PAYMENT_OPTIONS,
      OFFERING_CLASS,
      search: {
        lookback_days: 7,
        reservation_years: 1,
        payment_option: 'all_upfront',
        offering_class: 'standard',
      },
      list: this.$list.createList(this, {
        id: 'riListForAccount',
        resource: 'reservations',
        apiVersion: 'v1',
        getParams: {
          details: true,
          cloudaccount_id: this.data.id,
        },
        filterOptions: {
          resource_type: {
            label: this.$t('bill.ri_resource_type'),
          },
          category: {
            label: this.$t('bill.ri_category'),
          },
        },
      }),
      coverage: 0,
      duration: 0,
      utilization: 0,
      total_monthly_savings_amount: 0,
      // run_reservation: false,
    }
  },
  computed: {
    hasDefaultDate () {
      return !!(this.defaultDate && (this.defaultDate.start_day || this.defaultDate.start_date))
    },
    riReservationTips () {
      if (this.data.brand === 'Aws') {
        return this.$t('bill.aws_ri_switch')
      }
      return ''
    },
    columns () {
      const getTypeColumn = {
        field: 'resource_type',
        title: this.$t('bill.ri_resource_type'),
        showOverflow: 'ellipsis',
        minWidth: 100,
        formatter: ({ row }) => {
          return getBillResourceTypeLabel(row.resource_type)
        },
      }
      const getCategoryColumn = {
        field: 'category',
        title: this.$t('bill.ri_category'),
        showOverflow: 'ellipsis',
        minWidth: 100,
        formatter: ({ row }) => {
          return row.category || '-'
        },
      }
      const getSpecColumn = {
        field: 'spec',
        title: this.$t('bill.ri_spec'),
        showOverflow: 'ellipsis',
        minWidth: 100,
        formatter: ({ row }) => {
          return row.spec || '-'
        },
      }
      const getInstanceAmountColumn = {
        field: 'instance_amount',
        title: this.$t('bill.ri_instance_amount'),
        showOverflow: 'ellipsis',
        minWidth: 100,
        formatter: ({ row }) => {
          return `${row.instance_amount}` || '-'
        },
      }
      const getYearsColumn = {
        field: 'reservation_years',
        title: this.$t('bill.ri_reservation_years'),
        showOverflow: 'ellipsis',
        minWidth: 100,
        formatter: ({ row }) => {
          return RESERVATION_YEARS_MAP[row.reservation_years].value || '-'
        },
      }
      if (this.data.brand === 'Azure') {
        return [
          getTypeColumn,
          getCategoryColumn,
          getSpecColumn,
          getInstanceAmountColumn,
          getYearsColumn,
        ]
      }
      return [
        getTypeColumn,
        getCategoryColumn,
        getSpecColumn,
        getInstanceAmountColumn,
        {
          field: 'monthly_savings_amount',
          title: this.$t('bill.ri_monthly_savings_amount'),
          showOverflow: 'ellipsis',
          minWidth: 100,
          formatter: ({ row }) => {
            const money = numerify(row.monthly_savings_amount, '0,0.00')
            const currencySign = row.currency === 'CNY' ? currencyUnitMap.CNY.sign : currencyUnitMap.USD.sign
            return `${currencySign} ${money}` || '-'
          },
        },
        {
          field: 'offering_class',
          title: this.$t('bill.ri_payment'),
          showOverflow: 'ellipsis',
          minWidth: 100,
          formatter: ({ row }) => {
            return OFFERING_CLASS_MAP[row.offering_class && row.offering_class.toLowerCase()].value || '-'
          },
        },
        getYearsColumn,
        {
          field: 'payment_option',
          title: this.$t('bill.ri_payment_option'),
          showOverflow: 'ellipsis',
          minWidth: 100,
          formatter: ({ row }) => {
            return PAYMENT_OPTIONS_MAP[row.payment_option && row.payment_option.toLowerCase()].value || '-'
          },
        },
        {
          field: 'upfront_cost',
          title: this.$t('bill.ri_upfront_cost'),
          showOverflow: 'ellipsis',
          minWidth: 100,
          formatter: ({ row }) => {
            const money = numerify(row.upfront_cost, '0,0.00')
            const currencySign = row.currency === 'CNY' ? currencyUnitMap.CNY.sign : currencyUnitMap.USD.sign
            return `${currencySign} ${money}` || '-'
          },
        },
        {
          field: 'monthly_cost',
          title: this.$t('bill.ri_monthly_cost'),
          showOverflow: 'ellipsis',
          minWidth: 100,
          formatter: ({ row }) => {
            const money = numerify(row.monthly_cost, '0,0.00')
            const currencySign = row.currency === 'CNY' ? currencyUnitMap.CNY.sign : currencyUnitMap.USD.sign
            return `${currencySign} ${money}` || '-'
          },
        },
        {
          field: 'average_utilization',
          title: this.$t('bill.ri_average_utilization'),
          showOverflow: 'ellipsis',
          minWidth: 100,
          slots: {
            default: ({ row, column }) => {
              const percentage = row.average_utilization * 100
              return [
                <BillProgress percentage={ percentage } colors={ ['rgb(245, 34, 45', 'rgb(250, 173, 20)', '#52c41a'] } ranges={ [60, 90] }></BillProgress>,
                <span>{ percentage.toFixed(2) }%</span>,
              ]
            },
          },
        },
      ]
    },
    exportDataOptions () {
      const exportDataOptions = {
        items: [],
      }
      const sameColumns = [
        { label: this.$t('bill.ri_resource_type'), key: 'resource_type' },
        { label: this.$t('bill.ri_category'), key: 'category' },
        { label: this.$t('bill.ri_spec'), key: 'spec' },
        { label: this.$t('bill.ri_instance_amount'), key: 'instance_amount' },
        { label: this.$t('bill.ri_reservation_years'), key: 'reservation_years' },
      ]
      const columns = [
        { label: this.$t('bill.ri_monthly_savings_amount'), key: 'monthly_savings_amount' },
        { label: this.$t('bill.ri_payment_option'), key: 'payment_option' },
        { label: this.$t('bill.ri_payment'), key: 'offering_class' },
        { label: this.$t('bill.ri_upfront_cost'), key: 'upfront_cost' },
        { label: this.$t('bill.ri_monthly_cost'), key: 'monthly_cost' },
        { label: this.$t('bill.ri_average_utilization'), key: 'average_utilization' },
      ]
      if (this.data.brand === 'Azure') {
        exportDataOptions.items = sameColumns
      } else {
        exportDataOptions.items = sameColumns.concat(columns)
      }
      return exportDataOptions
    },
  },
  watch: {
    search: {
      handler (val) {
        this.getAmount()
        this.fetchData()
      },
      deep: true,
    },
    dateParam: {
      handler () {
        this.fetchCoverageData()
      },
      deep: true,
    },
  },
  created () {
    this.fetchData()
    if (this.dateParam.start_day && this.dateParam.end_day) {
      this.fetchCoverageData()
    }
    this.getAmount()
  },
  methods: {
    getInitialDateParam () {
      if (this.defaultDate && (this.defaultDate.start_day || this.defaultDate.start_date)) {
        const { start_date, end_date, start_day, end_day, ...rest } = this.defaultDate
        return {
          ...rest,
          start_day: start_day || this.toDayParam(start_date),
          end_day: end_day || this.toDayParam(end_date),
        }
      }
      return {
        start_day: this.$moment().startOf('month').format('YYYYMMDD'),
        end_day: this.$moment().endOf('month').format('YYYYMMDD'),
      }
    },
    toDayParam (val) {
      if (!val) return val
      if (/^\d{8}$/.test(String(val))) return val
      return this.$moment(String(val).replace('TZ', '')).format('YYYYMMDD')
    },
    fetchData () {
      this.list.getParams = { ...this.list.getParams, ...this.search }
      this.list.fetchData()
    },
    fetchCoverageData () {
      const coverageList = this.$refs.coverageList
      if (coverageList) {
        coverageList.fetchData()
      }
    },
    formatUsageHours (val) {
      const n = Number(val)
      if (Number.isNaN(n)) return 0
      if (Number.isInteger(n)) return n
      return parseFloat(n.toFixed(2))
    },
    onCoverageStats ({ coverage, usage_hours, utilization }) {
      this.coverage = `${((coverage || 0) * 100).toFixed(2)}%`
      this.duration = this.formatUsageHours(usage_hours)
      this.utilization = `${((utilization || 0) * 100).toFixed(2)}%`
    },
    async getAmount () {
      try {
        const params = {
          ...this.list.getParams,
          ...this.search,
          limit: 1,
          cloudaccount_id: this.data.id,
          $t: uuid(),
          scope: this.$store.getters.scope,
        }
        const { data } = await new this.$Manager('reservations', 'v1').list({ params })
        const curData = data.data[0]
        if (curData) {
          const unit = curData.currency === 'CNY' ? currencyUnitMap.CNY.sign : currencyUnitMap.USD.sign
          const total = numerify(curData.total_savings_amount, '0,0.00')
          this.total_monthly_savings_amount = ` ${unit}${total}`
        } else {
          this.total_monthly_savings_amount = 0
        }
      } catch (error) {
        throw error
      }
    },
    onAwsRICallChange (val) {
      try {
        const m = new this.$Manager('reservations', 'v1')
        const data = {
          cloudaccount_id: this.data.id,
        }
        if (val) {
          m.performClassAction({
            action: 'enable',
            data,
          })
        } else {
          m.performClassAction({
            action: 'disable',
            data,
          })
        }
      } catch (error) {
        throw error
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ri-header {
  border-bottom: 1px solid #5e6978;
  padding-bottom: 8px;
  color: #1a2736;
  font-size: 16px;
  margin-bottom: 5px;
}
.money {
  font-weight: 600;
  color: #4FA1F8;
  font-size: 18px;
}
</style>
